<template>
  <div>
    <el-card>
      <el-form
        label-position="top"
        size="small"
        :model="formParam"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <!-- 揽收订单号 -->
            <el-form-item :label="$t('collectionCenter.lanshouOrderNum')" class="numberSearch">
              <el-input
                v-model="formParam.carNumber"
                :placeholder="$t('collectionCenter.max2000Line')"
                type="textarea"
                :rows="4"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div>
              <!--查询-->
              <el-button
                type="primary"
                icon="el-icon-search"
                size="mini"
                @click="search"
              >{{ $t('basicData.Search') }}
              </el-button>
              <!--重置-->
              <el-button
                icon="el-icon-refresh"
                size="mini"
                @click="onReset"
              >{{ $t('basicData.reset') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height - 10"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="80"
          fixed="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--揽收订单号-->
        <el-table-column prop="orderNumber" :label="$t('collectionCenter.lanshouOrderNum')" min-width="200" />
        <!--商品发票号-->
        <el-table-column prop="goodsInvoicNo" :label="$t('collectionCenter.commodityInvoiceNumber')" min-width="200" />
        <!--商品发票秘钥-->
        <el-table-column prop="goodsInvoiceSecretKey" :label="$t('collectionCenter.CommodityInvoiceKey')" min-width="200" />
        <!--商品货运员-->
        <el-table-column prop="goodsFreightTaker" :label="$t('mdfeTranslate.CargoHandler')" min-width="200" />
        <!--商品发票代码-->
        <el-table-column prop="goodsInvoiceCode" :label="$t('mdfeTranslate.InvoiceCode')" min-width="200" />
        <!--商品发票金额-->
        <el-table-column prop="goodsInvoiceMoney" :label="$t('mdfeTranslate.InvoiceAmount')" min-width="200" />
        <!--商品发票序列号-->
        <el-table-column prop="invoiceSerialNumber" :label="$t('mdfeTranslate.InvoiceSerialNumber')" min-width="200" />
        <!--商品发票时间-->
        <el-table-column prop="invoiceTime" :label="$t('mdfeTranslate.InvoiceTime')" min-width="200" />
        <!--物流发票类型-->
        <el-table-column prop="logisticsInvoiceType" :label="$t('collectionCenter.LogisticsInvoiceType')" min-width="200" />
        <!--物流发票号-->
        <el-table-column prop="logisticsInvoiceNo" :label="$t('collectionCenter.logisticsInvoiceNumber')" min-width="200" />
        <!--物流发票秘钥-->
        <el-table-column prop="logisticsInvoiceSecretKey" :label="$t('mdfeTranslate.LogisticsInvoiceKey')" min-width="200" />
        <!--物流货运员-->
        <el-table-column prop="logisticsFreightTaker" :label="$t('mdfeTranslate.LogisticsCargoHandler')" min-width="200" />
        <!--物流发票代码-->
        <el-table-column prop="logisticsInvoiceCode" :label="$t('mdfeTranslate.LogisticsInvoiceCode')" min-width="200" />
        <!--物流发票金额-->
        <el-table-column prop="logisticsInvoiceMoney" :label="$t('mdfeTranslate.LogisticsInvoiceAmount')" min-width="200" />
        <!--买家税号Cpf-->
        <el-table-column prop="buyerCpf" :label="$t('mdfeTranslate.BuyerTaxNumber') + ' CPF'" min-width="200" />
        <!--买家税号Cnpg-->
        <el-table-column prop="buyerCnpg" :label="$t('mdfeTranslate.BuyerTaxNumber') + ' CNPG'" min-width="200" />
        <!--买家邮政编码-->
        <el-table-column prop="buyerPhone" :label="$t('mdfeTranslate.BuyerPostalCode')" min-width="200" />
        <!--买家地址-州-->
        <el-table-column prop="buyerState" :label="$t('mdfeTranslate.BuyerAddress') + '-' + $t('CenterForSorting.state')" min-width="200" />
        <!--买家地址-城市-->
        <el-table-column prop="buyerCity" :label="$t('mdfeTranslate.BuyerAddress') + '-' + $t('collectionCenter.city')" min-width="200" />
        <!--买家地址-邮编-->
        <el-table-column prop="buyerCityCode" :label="$t('mdfeTranslate.BuyerAddress') + '-' + $t('collectionCenter.Zip')" min-width="160" />
        <!--买家地址-区-->
        <el-table-column prop="buyerArea" :label="$t('mdfeTranslate.BuyerAddress') + '-' + $t('collectionCenter.Area')" min-width="200" />
        <!--买家地址-街道-->
        <el-table-column prop="buyerStreet" :label="$t('mdfeTranslate.BuyerAddress') + '-' + $t('collectionCenter.RecipientStreet')" min-width="200" />
        <!--买家详细地址-->
        <el-table-column prop="buyerAddress" :label="$t('mdfeTranslate.BuyerDetailedAddress')" min-width="200" />
        <!--买家邮箱-->
        <el-table-column prop="buyerEmail" :label="$t('mdfeTranslate.BuyerEmail')" min-width="200" />
        <!--买家名称，公司名或个人名称-->
        <el-table-column prop="buyerName" :label="$t('mdfeTranslate.BuyerNameCompanyNameOrPersonalName')" min-width="200" />
        <!--创建时间-->
        <el-table-column prop="updateTime" :label="$t('collectionCenter.CreationTime')" min-width="180" />
        <!--创建人-->
        <el-table-column prop="updateUserStr" :label="$t('collectionCenter.creator')" min-width="180" />
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentTable"
          @size-change="getSizeTable"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import { getNfseCollectCheckPage } from '@/api/invoiceCenter';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight';

export default {
  name: 'Collect',
  mixins: [estimateTableHeight],
  data() {
    return {
      formParam: {
        carNumber: ''
      },
      tableData: [],
      total: 0,
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          orderNumbers: []
        }
      }
    };
  },
  methods: {
    // 查询条件处理
    handleFormData() {
      const param = [];
      const val = this.formParam.carNumber.split('\n');
      // 过滤空项
      const numLen = val.filter(function(f) {
        return f && f.trim();
      });
      // 去除空格
      const carNumber = numLen.map(item => {
        return item.replace(/\s/g, '').trim();
      });
      carNumber.map(item => {
        if (param.includes(item) === false) {
          param.push(item);
        }
      });
      return param;
    },
    // 查询
    search() {
      this.queryForm.pageNumber = 1;
      this.searchTable();
    },
    // 获取列表数据
    searchTable() {
      const param = this.handleFormData();
      if (param.length > 2000) {
        this.$message.error(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      this.queryForm.params.orderNumbers = param;
      getNfseCollectCheckPage(this.queryForm).then(res => {
        if (res.code === 200) {
          res.data.records.map(item => {
            if (item.updateUser) {
              item.updateUserStr = this.userObj[item.updateUser] || '';
            }
            if (item.invoiceJson) {
              item.invoiceJson = JSON.stringify(JSON.parse(item.invoiceJson), null, 2);
            }
          });
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 重置
    onReset() {
      this.formParam = {
        carNumber: ''
      };
      this.queryForm.params.orderNumbers = [];
    },
    // 翻页
    getCurrentTable(val) {
      this.queryForm.pageNumber = val;
      this.searchTable();
    },
    // 改变每页显示数量
    getSizeTable(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.searchTable();
    }
  }
};
</script>

<style scoped>

</style>
